import { type FC } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

interface NavItem {
  path: string;
  label: string;
  icon: string;
}

const MobileBottomNav: FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, isAdmin } = useAuth();

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  const navItems: NavItem[] = [
    { path: '/', label: '번호 생성', icon: 'ri-shuffle-line' },
    { path: '/statistics', label: '통계', icon: 'ri-bar-chart-line' },
    { path: '/guide', label: '이용방법', icon: 'ri-book-open-line' },
    ...(user ? [{ path: '/my-numbers', label: '내 번호', icon: 'ri-heart-line' }] : []),
    ...(isAdmin ? [{ path: '/admin', label: '관리자', icon: 'ri-shield-check-line' }] : []),
    ...(user
      ? [{ path: '/account', label: '내 정보', icon: 'ri-user-settings-line' }]
      : [{ path: '/login', label: '로그인', icon: 'ri-login-box-line' }]
    ),
  ];

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-background-50/95 backdrop-blur-md border-t border-background-200 safe-area-bottom">
      <div className="flex items-center justify-around h-16 px-2">
        {navItems.map((item) => {
          const active = isActive(item.path);
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`
                flex flex-col items-center justify-center gap-0.5 min-w-0 flex-1 h-full
                transition-all duration-150 active:scale-90 cursor-pointer
                touch-manipulation select-none
                ${active ? 'text-primary-600' : 'text-foreground-400'}
              `}
            >
              <div className={`
                w-10 h-7 flex items-center justify-center rounded-full transition-colors
                ${active ? 'bg-primary-100' : ''}
              `}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <span className="text-[10px] font-medium whitespace-nowrap leading-tight">
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;